import React from 'react';
import { Button } from 'antd';

const SegmentedToggle = ({ options, value, onChange, className }) => (
    <div className={`collections-view-toggle-wrapper ${className || ''}`}>
        <Button.Group className="collections-view-toggle">
            {options.map(opt => (
                <Button
                    key={opt.value}
                    type={value === opt.value ? 'primary' : 'default'}
                    onClick={() => onChange(opt.value)}
                    className="view-toggle-btn"
                >
                    {opt.text || opt.label}
                    {opt.count != null && (
                        <span className={`toggle-count-chip ${value === opt.value ? 'toggle-count-active' : ''}`}>
                            {opt.count}
                        </span>
                    )}
                </Button>
            ))}
        </Button.Group>
    </div>
);

export default SegmentedToggle;
